import { validateTidalLicense } from "../../base/index.js";
import { trim } from "./trim.js";
function truncate(source, maxChars, suffix = "", onlyFullWords = false) {
  const maxLength = onlyFullWords ? maxChars + 1 : maxChars;
  let txt = trim(source);
  if (txt.length <= maxLength) return txt;
  txt = txt.slice(0, maxLength - suffix.length);
  txt = onlyFullWords ? txt.slice(0, txt.lastIndexOf(" ")) : trim(txt);
  return `${txt}${suffix}`;
}
validateTidalLicense();
export {
  truncate
};
//# sourceMappingURL=truncate.js.map
